import { Flex, Image, Text } from '@mantine/core';

import logo from '../../assets/logo.svg'

interface IHeader {
  t: any;
  title: string;
}

const Header = ({ t, title }: IHeader) => {
  return (
    <Flex align={'center'} direction={'column'} mt={40}>
      <Image src={logo} mb={10} w={130} h={90} />
      <Text style={{ fontSize: 24, textAlign: 'center' }}>{t('header.company')}</Text>
      <Text style={{ fontSize: 32, textAlign: 'center' }} mt={20}>{title}</Text>
    </Flex>
  )
}

export default Header;